module.exports = __webpack_public_path__ + "img/shipo-menu-schedule-of-shipment-white.312b051f.svg";